import { render, staticRenderFns } from "./DescargasMetadata.vue?vue&type=template&id=5e2f9866&scoped=true&"
import script from "./DescargasMetadata.vue?vue&type=script&lang=js&"
export * from "./DescargasMetadata.vue?vue&type=script&lang=js&"
import style0 from "./DescargasMetadata.vue?vue&type=style&index=0&id=5e2f9866&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2f9866",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QBtn,QSpinnerDots,QTable,QInput,QIcon,QTr,QTd,QTooltip});
